import { render, staticRenderFns } from "./TaskContent.vue?vue&type=template&id=b51023b6&"
import script from "./TaskContent.vue?vue&type=script&lang=ts&"
export * from "./TaskContent.vue?vue&type=script&lang=ts&"
import style0 from "./TaskContent.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports